import React from 'react'
import { connect } from 'react-redux'
import onlineVisitModalImage from '../../assets/img/online-visit/online-visit-image-modal.png'
import { getShowOnlineVisitModal } from '../../store/ui/reducers'
import { closeOnlineVisitModal } from '../../store/ui/actions'
import { getOnlineVisitUrl } from '../../store/login/reducers'
import Translation from '../global/Translation'

const OnlineVisitModal = props => {
    const { showOnlineVisitModal, onCloseOnlineVisitModal, onlineVisitUrl } = props

    const handleCloseModal = () => {
        return onCloseOnlineVisitModal()
    }

    return (
        <React.Fragment>
            {showOnlineVisitModal ? (
                <div>
                    <div className="full-overlay" style={{ display: 'block' }} />

                    <div className="modal-online-visit-container">
                        <div className="close-btn">
                            <button onClick={() => handleCloseModal()}>
                                <i className="fal fa-times" />
                            </button>
                        </div>
                        <div className="content">
                            <div className="visual-content">
                                <div className="visual__content__text">
                                    <div className="visual__content__text--new">
                                        <span>
                                            <Translation id="new" defaultMessage="New" />
                                        </span>
                                    </div>
                                    <div className="visual__content__text--main-text">
                                        <h3>
                                            <Translation id="online_visit" defaultMessage="Online visit" />
                                        </h3>
                                    </div>
                                    <div className="visual__content__text--centers">
                                        <h5>
                                            Cosentino
                                        </h5>
                                        <h5>
                                            <Translation id="natural_stone_brazil" defaultMessage="Natural stone Brazil" />
                                        </h5>
                                    </div>
                                    <div className="visual__content__text--info">
                                        <p>
                                            <Translation
                                                id="explore_our_variety_of_colors_and_select_natural_stone_slabs"
                                                defaultMessage="Explore our variety of colors and select natural stone slabs for your projects."
                                            />
                                        </p>
                                    </div>
                                    <div className="visual__content__text--btn">
                                        <a href={onlineVisitUrl} target="_blank" rel="noopener noreferrer">
                                            <button>
                                                <Translation id="book_a_visit_online_natural_stone_brazil" defaultMessage="Book a visit online Natural Stone Brazil" />
                                            </button>
                                        </a>
                                    </div>
                                </div>
                                <div className="visual__content__image">
                                    <img src={onlineVisitModalImage} alt="Online Visit" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : null}
        </React.Fragment>
    )
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onCloseOnlineVisitModal: () => {
            dispatch(closeOnlineVisitModal())
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        showOnlineVisitModal: getShowOnlineVisitModal(state),
        onlineVisitUrl: getOnlineVisitUrl(state)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OnlineVisitModal)
